import React, { createContext, useCallback, useState } from "react";

const MensagensPendentesContext = createContext();









const MensagensPendentesProvider = ({ children }) => {
  const [pendentes, setPendentes] = useState([]);

  const adicionar = useCallback((mensagem) => {
    setPendentes((atual) => [...atual, { ...mensagem, status: "enviando" }]);
  }, []);

  const remover = useCallback((tempId) => {
    setPendentes((atual) => atual.filter((m) => m.tempId !== tempId));
  }, []);

  const marcarFalha = useCallback((tempId, erro) => {
    setPendentes((atual) =>
      atual.map((m) =>
        m.tempId === tempId ? { ...m, status: "falhou", erro } : m
      )
    );
  }, []);

  const marcarEnviando = useCallback((tempId) => {
    setPendentes((atual) =>
      atual.map((m) =>
        m.tempId === tempId
          ? { ...m, status: "enviando", criadoEm: Date.now() }
          : m
      )
    );
  }, []);

  const doTicket = useCallback(
    (ticketId) =>
      pendentes.filter((m) => String(m.ticketId) === String(ticketId)),
    [pendentes]
  );

  return (
    <MensagensPendentesContext.Provider
      value={{
        pendentes,
        adicionar,
        remover,
        marcarFalha,
        marcarEnviando,
        doTicket,
      }}
    >
      {children}
    </MensagensPendentesContext.Provider>
  );
};

export { MensagensPendentesContext, MensagensPendentesProvider };
